module.exports = __webpack_public_path__ + "static/media/iguazu-falls-36.47fa2da1.jpg";